import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { Observable, map } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { TravelGuide } from '../../interfaces';

@Component({
  selector: 'cms-travel-guide',
  templateUrl: './cms-travel-guide.component.html',
  styleUrls: ['cms-travel-guide.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CmsTravelGuideComponent implements OnInit {
  readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input()
  content$: Observable<TravelGuide>;

  travelGuide$: Observable<TravelGuide>;
  related$: Observable<TravelGuide[]>;

  ngOnInit(): void {
    this.travelGuide$ = this.content$;
    this.related$ = this.content$.pipe(map((tg) => tg.related));
  }
}
